<script>
import { mapRoute } from '@src/router'
import LargeButtonWithArrow from '@comp/utils/LargeButtonWithArrow.vue'

export default {
  name: 'WelcomeButtons',
  components: {
    LargeButtonWithArrow,
  },
  methods: {
    goToMap () {
      this.$router.push({ name: mapRoute.name })
    },
  },
}
</script>
<template>
  <section class="card welcome-navigation">
    <LargeButtonWithArrow
      :callback="goToMap"
      :icon="'fas fa-search-location'"
      :text="$gettext('Go to map')"
    />
  </section>
</template>
<style lang="scss" scoped>
.welcome-navigation {
  flex-direction: row;
  flex-grow: 1;
  flex-shrink: 1;
  justify-content: space-evenly;
  align-items: center;
}

@media (width <= 1000px) {
  .welcome-navigation {
    flex-direction: column;
    width: 250px;
  }
}
</style>
